import { PromptTypeOption } from 'src/app/pages/prompt-register/models/prompt-type-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const promptTypeOptionActions = createEagerSelectActions<PromptTypeOption>('[Prompt Type Options]');
